import { useState } from 'react'

import { useIntl } from '@/intl'

export function useTexts() {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    searchPlaceholder: translate({ id: 'gps.trackinglist.list.filterVehicles' }),
    yourVehicles: translate({ id: 'gps.trackinglist.list.yourVehicles' }),

    entitiesCount: (selected: number, count: number): string =>
      translate({
        id:
          selected > 0
            ? 'setup.vehicles.list.footerCountWithSelection'
            : 'vehicles.form.footer.countVehicles',
        values: { count, selected },
      }),

    selectBtn: (allSelected: boolean): string =>
      translate({ id: allSelected ? 'global.deselectAll' : 'global.selectAll' }),
    visibilityBtn: (someVisible?: boolean): string =>
      translate({
        id: someVisible ? 'global.hideAll' : 'global.showAll',
      }),
    noBadges: translate({ id: 'gps.trackinglist.list.badgeFilter.noBadges.title' }),

    noEntries: {
      title: translate({ id: 'trackingList.list.noEntries.title' }),
      description: translate({ id: 'trackingList.list.noEntries.description' }),
    },
    noResults: {
      title: translate({ id: 'trackingList.list.noResults.title' }),
      description: translate({ id: 'trackingList.list.noResults.description' }),
    },
  }))

  return api
}
